<div class="card container col-11">
  <label class="section-label">{{'USER_ACTIVITY.TITLE' | translate}}</label>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SERVICE_REQUEST_STATUS' | translate}}</div>
    <div class="col-7">{{ userActivity?.serviceRequestStatus | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SERVICE_REQUEST_REVIEWED_BY' | translate}}</div>
    <div class="col-7">{{ userActivity?.serviceRequestReviewedBy | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SERVICE_REQUEST_REVIEW_DATE' | translate}}</div>
    <div class="col-7">
      {{ userActivity?.serviceRequestReviewDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
    </div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SITE_VERIFICATION_STATUS' | translate}}</div>
    <div class="col-7">{{ userActivity?.siteVerificationStatus | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SITE_VERIFICATION_CAPTURED_BY' | translate}}</div>
    <div class="col-7">{{ userActivity?.siteVerificationCapturedBy | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SITE_VERIFICATION_DATE' | translate}}</div>
    <div class="col-7">
      {{ userActivity?.siteVerificationDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
    </div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SITE_VERIFICATION_REVIEWED_BY' | translate}}</div>
    <div class="col-7">{{ userActivity?.siteVerificationReviewedBy | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.SITE_VERIFICATION_REVIEW_DATE' | translate}}</div>
    <div class="col-7">
      {{ userActivity?.siteVerificationReviewDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
    </div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.PROJECT_STATUS' | translate}}</div>
    <div class="col-7">{{ userActivity?.projectStatus | hasValue }}</div>
  </div>
  
  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.APPLICATION_STAGE' | translate}}</div>
    <div class="col-7">{{ userActivity?.applicationStage | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.ACCOUNT_GENERATION_DATE' | translate}}</div>
    <div class="col-7">
      {{ userActivity?.accountGeneratedDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
    </div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.ACCOUNT_GENERATED_BY' | translate}}</div>
    <div class="col-7">{{ userActivity?.accountGeneratedBy | hasValue }}</div>
  </div>

  <div class="row">
    <div class="col-5">{{'USER_ACTIVITY.APPLICATION_DATE' | translate}}</div>
    <div class="col-7">
      {{ userActivity?.applicationDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
    </div>
  </div>
  <ng-container *ngIf="showSurveyInstallation">
    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.SURVEY_STATUS' | translate}}</div>
      <div class="col-7">{{ surveyData?.surveyStatus | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.SURVEY_CAPTURED_BY' | translate}}</div>
      <div class="col-7">{{ surveyData?.surveyCapturedBy | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.SURVEY_DATE' | translate}}</div>
      <div class="col-7">
        {{ surveyData?.surveyDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
      </div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.SURVEY_REVIEWED_BY' | translate}}</div>
      <div class="col-7">{{ surveyData?.surveyReviewedBy | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.SURVEY_REVIEW_DATE' | translate}}</div>
      <div class="col-7">
        {{ surveyData?.surveyReviewDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
      </div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.INSTALLATION_STATUS' | translate}}</div>
      <div class="col-7">{{ installationData?.installationStatus | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.INSTALLATION_CAPTURED_BY' | translate}}</div>
      <div class="col-7">{{ installationData?.installationCapturedBy | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.INSTALLATION_DATE' | translate}}</div>
      <div class="col-7">
        {{ installationData?.installationDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
      </div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.INSTALLATION_REVIEWED_BY' | translate}}</div>
      <div class="col-7">{{ installationData?.installationReviewedBy | hasValue }}</div>
    </div>

    <div class="row">
      <div class="col-5">{{'USER_ACTIVITY.INSTALLATION_REVIEW_DATE' | translate}}</div>
      <div class="col-7">
        {{ installationData?.installationReviewDate | date : "dd/MM/yyyy HH:mm" | hasValue }}
      </div>
    </div>
  </ng-container>
</div>
